import { Component, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { ProductService } from '../../../product/product.service';
import { FileSaverService } from 'ngx-filesaver';
import { b64ToBlob } from 'src/app/core/helpers/b64ToBlob.helper';
import { SnackbarService } from 'src/app/core/services/snackbar.service';

@Component({
  selector: 'vex-product-bulk-update-modal',
  templateUrl: './product-bulk-update-modal.component.html',
  styleUrls: ['./product-bulk-update-modal.component.scss'],
})
export class ProductBulkUpdateModalComponent {
  selectedFile: File | null = null;
  fileNameHintInvalid = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { contractId: string },
    private dialogRef: MatDialogRef<ProductBulkUpdateModalComponent>,
    private productService: ProductService,
    private fileSaver: FileSaverService,
    private snackbar: SnackbarService,
  ) {}

  onFileChange(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input.files && input.files[0];
    this.selectedFile = file ?? null;
    const name = this.selectedFile?.name ?? '';
    // Helper hint: backend export uses name "ProductBulkUpdate" by default
    this.fileNameHintInvalid = !!this.selectedFile && !name.includes('ProductBulkUpdate');
  }

  cancel() {
    this.dialogRef.close();
  }

  exportTemplate() {
    this.productService.exportBulkUpdate(this.data.contractId).subscribe({
      next: x => {
        const b = b64ToBlob(x.data.b64, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
        this.fileSaver.save(b, `${x.data.fileName}.xlsx`);
        this.snackbar.success('Export téléchargé');
      },
      error: () => this.snackbar.danger("Erreur lors de l'export"),
    });
  }

  import() {
    if (!this.selectedFile) return;
    const formData = new FormData();
    formData.append('file-excel', this.selectedFile);
    this.productService.importBulkUpdate(formData).subscribe({
      next: () => {
        this.snackbar.success('Import effectué');
        this.dialogRef.close({ success: true });
      },
      error: err => {
        const errors = err?.error?.errors;
        if (errors?.length) {
          const message = errors.map((e: any) => `Ligne ${e.line}: ${e.message}`).join('\n');
          this.snackbar.danger(message);
        } else {
          this.snackbar.danger("Erreur lors de l'import");
        }
      },
    });
  }
}
